<form [formGroup]="partsManagementFilterForm">
  <div class="form-content">
    <div class="pure-g">
      <div class="pure-u-md-24-24">
        <div class="pure-u-md-24-24 p-b-12 p-r-16">
          <app-aems-multiline-tag-input
            label="Part Number"
            placeholder="Enter part number"
            [regex]="partnumberRegex"
            formControlName="partCodesList"></app-aems-multiline-tag-input>
        </div>

        <div class="pure-u-md-12-24 p-b-12 p-r-16">
          <mc-multi-select
            label="Part Group"
            fit="medium"
            width="100"
            placeholder="Select an Option"
            ngDefaultControl
            formControlName="partGroupCodeList">
            @for (partGroup of partGroupCodeList; track partGroup.code) {
              <mc-option [attr.data-cy]="partGroup.code" [value]="partGroup.code"
                >{{ partGroup.code }} - {{ partGroup.description }}</mc-option
              >
            }
          </mc-multi-select>
        </div>

        <div class="pure-u-md-12-24 p-b-12 p-r-16">
          <mc-multi-select
            label="Manufacturer Code"
            fit="medium"
            width="100"
            placeholder="Select an Option"
            ngDefaultControl
            formControlName="partManufacturerCodeList">
            @for (partManufacturerCode of partManufacturerCodeList; track partManufacturerCode.code) {
              <mc-option [attr.data-cy]="partManufacturerCode.code" [value]="partManufacturerCode.code"
                >{{ partManufacturerCode.code }} - {{ partManufacturerCode.description }}</mc-option
              >
            }
          </mc-multi-select>
        </div>

        <div class="pure-u-md-12-24 p-b-8 p-r-16">
          <app-aems-multiline-tag-input
            label="Description"
            [regex]="descriptionRegex"
            formControlName="description"></app-aems-multiline-tag-input>
          <p class="mds-text--x-small-normal mds-neutral--weak__text-color" style="margin-top: 4px; margin-bottom: 0">
            When you apply filters, you'll see results that match with the description you have entered.
          </p>
        </div>

        <div class="pure-u-md-12-24 p-b-8 p-r-16">
          <mc-checkbox-group class="p-b-8" legend="Active">
            <mc-checkbox
              value="Y"
              label="Y"
              [checked]="isValueSelected('partActiveStatusesList', 'Y')"
              (change)="onCheckChange('partActiveStatusesList', 'Y')"></mc-checkbox>
            <mc-checkbox
              value="N"
              label="N"
              [checked]="isValueSelected('partActiveStatusesList', 'N')"
              (change)="onCheckChange('partActiveStatusesList', 'N')"></mc-checkbox>
          </mc-checkbox-group>
        </div>

        <div class="pure-u-md-12-24 p-b-8 p-r-16">
          <mc-checkbox-group legend="Core">
            <mc-checkbox
              value="Y"
              label="Y"
              [checked]="isValueSelected('isSerialTagNumberRequired', 'Y')"
              (change)="onCheckChange('isSerialTagNumberRequired', 'Y')"></mc-checkbox>
            <mc-checkbox
              value="N"
              label="N"
              [checked]="isValueSelected('isSerialTagNumberRequired', 'N')"
              (change)="onCheckChange('isSerialTagNumberRequired', 'N')"></mc-checkbox>
          </mc-checkbox-group>
        </div>

        <div class="pure-u-md-12-24 p-b-8 p-r-16">
          <mc-checkbox-group legend="Deduct Core Value">
            <mc-checkbox
              value="Y"
              label="Y"
              [checked]="isValueSelected('deductCore', 'Y')"
              (change)="onCheckChange('deductCore', 'Y')"></mc-checkbox>
            <mc-checkbox
              value="N"
              label="N"
              [checked]="isValueSelected('deductCore', 'N')"
              (change)="onCheckChange('deductCore', 'N')"></mc-checkbox>
          </mc-checkbox-group>
        </div>
      </div>
    </div>
  </div>
  <div class="pure-u-md-24-24 utility-buttons">
    <mc-button
      label="Apply Filters"
      slot="primaryAction"
      variant="filled"
      appearance="primary"
      fit="medium"
      (click)="applyFilters()"
      class="p-r-16"></mc-button>
    <mc-button
      label="Clear Filters"
      slot="secondaryAction"
      appearance="neutral"
      fit="medium"
      (click)="clearFilters()"
      class="p-r-16"></mc-button>
  </div>
</form>
